import React from 'react';
import Image from '@/src/shared/components/Image';
import styles from './IntroductionSection.module.scss';

type Props = {
  size?: 'default' | 'small';
};

export function Graphic({ size }: Props) {
  return (
    <div className={styles.imageWrapper}>
      <Image
        src="/images/contact-us/new/introduction.svg"
        alt=""
        width={size === 'small' ? 438.39 - 150 : 372}
        height={size === 'small' ? 415.57 - 150 : 539}
        objectFit="contain"
        objectPosition="center"
      />
    </div>
  );
}
